/* import $ from 'jquery';
import 'owl.carousel';

export function initializeSeedCarousel() {
    $('.carouselSeedSection').owlCarousel({
        loop: true,
        center: true,
        margin: -10,
        nav: true,
        navText: [
            "<svg xmlns='http://www.w3.org/2000/svg' width='80' height='81' viewBox='0 0 80 81' fill='none'><path d='M53.5342 8.00001L23.8086 39.25L53.5342 70.5' stroke='#F0533A' stroke-width='7.5' stroke-linecap='round' stroke-linejoin='round'/></svg>",
            "<svg xmlns='http://www.w3.org/2000/svg' width='80' height='81' viewBox='0 0 80 81' fill='none'><path d='M26.4658 73L56.1914 41.75L26.4658 10.5' stroke='#F0533A' stroke-width='7.5' stroke-linecap='round' stroke-linejoin='round'/></svg>"
        ],
        responsive: {
            0: {
                items: 1,
                nav: true,
                margin: 0
            },
            990: {
                items: 3,
                nav: true,
                margin: 0,
                stagePadding: 27
            },
            1100: {
                items: 5,
                nav: true,
                margin: 0
            },
            1600: {
                items: 5,
                nav: true,
                margin: -10
            }
        }
    });

    // Función para actualizar las clases
    function updateClasses() {
        const centerIndex = $('.carouselSeedSection').find('.owl-item.center').index(); 
        $('.owl-item.big').removeClass('big'); 
        $('.owl-item.medium').removeClass('medium');
        $('.owl-item').eq(centerIndex).addClass('big'); 
        $('.owl-item').eq(centerIndex - 1).addClass('medium'); 
        $('.owl-item').eq(centerIndex + 1).addClass('medium'); // Agrega la clase 'medium' al siguiente item
    }

    // Inicializar las clases al inicio
    $('.carouselSeedSection').on('initialized.owl.carousel', function () {
        setTimeout(updateClasses, 10); // Llama a updateClasses después de un breve retraso
    });

    // Actualizar clases al cambiar de item
    $('.carouselSeedSection').on('translate.owl.carousel', function () {
        updateClasses(); // Actualiza las clases cuando se traduce
    });
}

// Llama a la función de inicialización en el DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
    initializeSeedCarousel();
});
 */